import {Stack, Switch} from "@mui/material";
import Typography from "@mui/material/Typography";
import {forwardRef, useImperativeHandle, useState} from "react";

const HiddenContentSwitch = forwardRef((props, hiddenContentRef) => {
    const [hiddenCheckboxChecked, setHiddenCheckboxChecked] = useState(false);

    useImperativeHandle(hiddenContentRef, () => {
        return hiddenCheckboxChecked;
    });

    return <>
        <label htmlFor={'hiddenContentSwitch'}>
            <Stack
                direction='column'
                alignItems={'start'}
                justifyContent={'center'}
                spacing={1} mt={2}
                borderRadius={1} p={1}
                sx={{
                    cursor: 'pointer',
                    transition: 'all ease-out .3s',
                    '&:hover': {
                        backgroundColor: '#efefef',
                    }
                }}>

                <Stack direction={'row'} maxWidth={400}>
                    <Switch
                        id={'hiddenContentSwitch'}
                        onChange={() => {setHiddenCheckboxChecked((prevValue) => !prevValue)}}
                        inputRef={hiddenContentRef} />
                    <Typography variant="h6">
                        Nascondi dati sensibili
                    </Typography>
                </Stack>
                <Stack direction='column' overflow={'hidden'} m={0} p={0} sx={{
                    transition: 'all ease-out .3s',
                    maxHeight: hiddenCheckboxChecked ? '150px' : '0px',
                    overflowY: hiddenCheckboxChecked ? 'auto' : 'hidden'
                }}>
                    <Typography variant="body2" sx={{opacity: .6}}>
                        Spuntando questa casella verranno oscurati tutti i dati sensibili presenti all'interno dell'audio (nomi, email, numeri di telefono, account utente e informazioni di localizzazione).
                    </Typography>
                    <Typography variant="body2" fontWeight={'bold'}  sx={{opacity: .6}}>
                        Attenzione: i dati non saranno più visibili all'interno della trascrizione
                    </Typography>
                </Stack>
            </Stack>
        </label>
    </>
});

export default HiddenContentSwitch;